module.exports = __webpack_public_path__ + "static/img/static_bg3.a343be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/static_bg3.png
// module id = 8WCB
// module chunks = 37